"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WHEN_AXES = exports.CONTEXT_DOMAINS = exports.SATELLITE_MOVE_WARNING_DAYS = exports.APPROACHING_WINDOW_DAYS = void 0;
exports.isSatelliteExpectation = isSatelliteExpectation;
const browser_1 = require("encamp-prisma/generated/browser");
// TIME limits; pending team confirm
exports.APPROACHING_WINDOW_DAYS = 30;
// The nightly deadline-flag sweep's satellite warning threshold. Deliberately
// narrower than the chip's move-window treatment, which shows APPROACHING for
// the whole 3-day window: an alert one day out, a visual cue immediately.
exports.SATELLITE_MOVE_WARNING_DAYS = 1; // decision log #15
function isSatelliteExpectation(row) {
    return row.when.areaType === "SATELLITE";
}
/**
 * A runtime table of every value each of `R`'s attributes can take, checked
 * for completeness AT COMPILE TIME in both directions: a missing attribute
 * fails the mapped constraint, and an array missing a value of its
 * attribute's type fails that entry with a "missing domain values:" error.
 */
function domainsOf() {
    return (domains) => domains;
}
/**
 * Every value each context attribute can take — the input space the sweep
 * and the SME export agree on, derived from `RuleContext` itself. Extending
 * the context fails to compile until this table follows, which is what lets
 * the sweep's breadth be trusted by construction.
 */
exports.CONTEXT_DOMAINS = domainsOf()({
    areaType: ["CENTRAL", "SATELLITE"],
    generatorStatus: ["LQG", "SQG", "VSQG", null],
    // The enum object is the runtime source of its own values, so this entry is
    // complete by construction rather than by a hand-kept list.
    stateGeneratorStatus: [...Object.values(browser_1.StateRegulatoryStatus), null],
    mustTransport200Miles: [false, true],
    wasteKind: ["UNIVERSAL_WASTE", "USED_OIL", "PHARMACEUTICAL", null],
    operatesUnderSubpartP: [false, true],
    managedAsUniversalWaste: [false, true],
});
/**
 * The axes in the order tables present them — a key list rather than a value
 * table, kept complete against the resolver's parameters by the same style
 * of compile-time guard.
 */
exports.WHEN_AXES = everyValueOf()([
    "generatorStatus",
    "stateGeneratorStatus",
    "mustTransport200Miles",
    "wasteKind",
    "operatesUnderSubpartP",
    "managedAsUniversalWaste",
]);
function everyValueOf() {
    return (values) => values;
}
//# sourceMappingURL=types.js.map